// @ts-nocheck
import axios from 'axios';
import API_ENDPOINTS from '../const/ApiEndPoints';

const useSegments = () => {
  // GET - Get all segments
  const getSegments = (params, loader = true) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.SEGMENTS.GET_SEGMENTS}`,
        {
          params,
          loader: loader,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  // GET - Get single segment with attributes
  const getSegment = (params) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.SEGMENTS.GET_SEGMENTS}`,
        {
          params,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  // POST - Create new segment
  const createSegment = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.SEGMENTS.CREATE_SEGMENT}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  // PUT - Update segment
  const updateSegment = (body) => {
    return axios
      .put(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.SEGMENTS.UPDATE_SEGMENT}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  // DELETE - Delete segment
  const deleteSegment = (params) => {
    return axios
      .delete(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.SEGMENTS.DELETE_SEGMENT}`,
        {
          params,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  // GET - Check for duplicate segment
  const duplicateSegment = (params) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.SEGMENTS.DUPLICATE_SEGMENT}`,
        {
          params,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  // GET - Check for  segment creation status
  const segmentCreationStatus = (params, loader = true) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.SEGMENTS.CHECK_INPROGRESS}`,
        {
          params,
          loader: loader,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  return {
    getSegments,
    getSegment,
    createSegment,
    updateSegment,
    deleteSegment,
    duplicateSegment,
    segmentCreationStatus,
  };
};

export default useSegments;
